import { render, staticRenderFns } from "./TabTwo.vue?vue&type=template&id=172cd2cc&scoped=true&"
import script from "./TabTwo.vue?vue&type=script&lang=js&"
export * from "./TabTwo.vue?vue&type=script&lang=js&"
import style0 from "./TabTwo.vue?vue&type=style&index=0&id=172cd2cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172cd2cc",
  null
  
)

export default component.exports